import type { Palette } from "@designboticteam/core";

const TONES = {
	primary: {
		0: "#000000",
		10: "#231804",
		20: "#432F07",
		30: "#65470B",
		40: "#875F10",
		50: "#A77612",
		60: "#CB9015",
		70: "#E8A829",
		80: "#ECB853",
		90: "#F1CB7E",
		95: "#F7DCA8",
		99: "#FAEED4",
		100: "#ffffff",
	},
	secondary: {
		0: "#000000",
		10: "#111614",
		20: "#252929",
		30: "#373E3D",
		40: "#495251",
		50: "#5C6866",
		60: "#6F7D7B",
		70: "#859391",
		80: "#9DA9A8",
		90: "#B6BEBC",
		95: "#E7E9E9",
		99: "#FFFBFE",
		100: "#FFFFFF",
	},
	tertiary: {
		0: "#000000",
		10: "#0C2427",
		20: "#18484F",
		30: "#21636D",
		40: "#2B7F8C",
		50: "#359CAC",
		60: "#44B6C5",
		70: "#62C1CF",
		80: "#82CDD9",
		90: "#A1D9E2",
		95: "#C1E6EC",
		99: "#E0F3F5",
		100: "#FFFFFF",
	},
	error: {
		0: "#000000",
		10: "#290C00",
		20: "#551800",
		30: "#7D2300",
		40: "#A82F01",
		50: "#D23A01",
		60: "#FC4700",
		70: "#FF6528",
		80: "#FF8454",
		90: "#FFA37E",
		95: "#FEC1A9",
		99: "#FFE0D4",
		100: "#FFFFFF",
	},
	graphite: {
		0: "#000000",
		10: "#141416",
		20: "#28282A",
		30: "#3D3D40",
		40: "#525256",
		50: "#67676C",
		60: "#7C7C83",
		70: "#919197",
		80: "#A8A7AB",
		90: "#BCBCC0",
		95: "#D3D3D5",
		99: "#E9E9EA",
		100: "#FFFFFF",
	},
	background: {
		0: "#000000",
		10: "#1B1B16",
		20: "#36362C",
		30: "#515142",
		40: "#6C6C57",
		50: "#87876E",
		60: "#9E9E88",
		70: "#B5B4A3",
		80: "#CAC9BE",
		90: "#E0E0D9",
		95: "#F5F5F2",
		99: "#FBFBFA",
		100: "#FFFFFF",
	},
} as const;

const MAIN_COLORS = {
	primary: TONES.primary[60],
	secondary: TONES.secondary[60],
	tertiary: TONES.tertiary[60],
	error: TONES.error[60],
} as const;

const ACCENT_COLORS = {
	primary: TONES.primary[99],
	graphite: TONES.graphite[60],
} as const;

const NEUTRAL_COLORS = {
	graphite: TONES.graphite[20],
	background: TONES.background[95],
	white: TONES.graphite[100],
	black: TONES.graphite[0],
} as const;

const PALETTE = {
	main: MAIN_COLORS,
	accent: ACCENT_COLORS,
	neutral: NEUTRAL_COLORS,
	tones: TONES,
} as const satisfies Palette;

export { PALETTE };
